import { render, staticRenderFns } from "./endoscopy.vue?vue&type=template&id=0d54d7fb&scoped=true&"
import script from "./endoscopy.vue?vue&type=script&lang=js&"
export * from "./endoscopy.vue?vue&type=script&lang=js&"
import style0 from "./endoscopy.vue?vue&type=style&index=0&id=0d54d7fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d54d7fb",
  null
  
)

export default component.exports